import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import { EntityPage, DocumentsPage } from "@/pages/EntityPage";
import TrustDetail from "@/pages/TrustDetail";
import Users from "@/pages/Users";
import Logs from "@/pages/Logs";
import AccessReview from "@/pages/AccessReview";
import Backup from "@/pages/Backup";
import Compliance from "@/pages/Compliance";
import ImportData from "@/pages/ImportData";
import Integrations from "@/pages/Integrations";
import ContractPage from "@/pages/ContractPage";
import SigningDone from "@/pages/SigningDone";
import { PrivacyPage, CookiePage } from "@/pages/Legal";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-slate-400">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

const MGR = ["admin", "gestore_utenti"];

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/cookie" element={<CookiePage />} />
      <Route path="/firma-completata" element={<SigningDone />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="trusts" element={<EntityPage entity="trusts" />} />
        <Route path="trusts/:id" element={<TrustDetail />} />
        <Route path="subjects" element={<EntityPage entity="subjects" />} />
        <Route path="prospects" element={<EntityPage entity="prospects" />} />
        <Route path="prospects/:pid/contract" element={<Protected roles={["admin", "gestore_utenti", "collaboratore"]}><ContractPage /></Protected>} />
        <Route path="deadlines" element={<EntityPage entity="deadlines" />} />
        <Route path="fiscal" element={<EntityPage entity="fiscal" />} />
        <Route path="chart-of-accounts" element={<EntityPage entity="chart_of_accounts" />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="users" element={<Protected roles={MGR}><Users /></Protected>} />
        <Route path="access-review" element={<Protected roles={MGR}><AccessReview /></Protected>} />
        <Route path="logs" element={<Protected roles={MGR}><Logs /></Protected>} />
        <Route path="backup" element={<Protected roles={["admin"]}><Backup /></Protected>} />
        <Route path="compliance" element={<Protected roles={["admin"]}><Compliance /></Protected>} />
        <Route path="import" element={<Protected roles={["admin"]}><ImportData /></Protected>} />
        <Route path="integrations" element={<Protected roles={["admin"]}><Integrations /></Protected>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
